
//jQuery(document).ready(function(){
	
	//jQuery(".map_point_item").click(function(){			
	//	jQuery('#india').toggleClass("active1");
		//jQuery(this).parents(".map_wrapper").find('#india').addClass("active");
	//});
	//jQuery(".map-block .common span").click(function(){
		//alert("dsfdf");
	//	jQuery(this).parents(".map_wrapper").find('#india').removeClass("active1");
	//});
	
//});


jQuery(function(){
  jQuery('.map_container .map_point_item').click(function(e) {
      e.preventDefault();
      e.isPropagationStopped();
      jQuery(this).parents('.map_container ').find('.map_point_item').removeClass('active1');
      jQuery(this).parents('.map_container ').find('.common').removeClass('active1');
      jQuery(this).addClass('active1');				
      jQuery(this).parents('.map_container ').find('.common:nth-of-type('+(jQuery(this).parents('.map_container').find('.map_point_item.active1').index() + 2)+')').addClass('active1');
  });

  jQuery(".map_container .common span").click(function(){
		//alert("dsfdf");
		jQuery(this).parents(".map_container").find('.active1').removeClass("active1");
	});


  
});

jQuery('.scroll').click(function() {
  jQuery('body').animate({
      scrollTop: eval(jQuery('#' + jQuery(this).attr('target')).offset().top - 70)
  }, 1000);
});




    $(function() {
       

        window.onload = function() {
    var headerHeight = $(".header-wrapper").height() + "px";
    $(".recipe_top_area").css("margin-top", headerHeight);
  };

      });



    window.onload = function() {
        fb_share.href ='http://www.facebook.com/share.php?u=' + encodeURIComponent(location.href); 
        twt_share.href ='https://x.com/intent/tweet?text=' + encodeURIComponent(location.href);
    }  

 

      




jQuery(function(){
  //jQuery.noConflict();
  jQuery(".fancybox").fancybox();
});



$('.content_slide ').slick({

  centerPadding: '30',
  slidesToShow: 1,
   arrows: true,
   dot: false,
   autoplay: true
   
});





jQuery('.testimonials').slick({

  centerPadding: '40',
  slidesToShow: 3,
   arrows: true,
   dot: false,
   autoplay: true,
   



   responsive: [

   
    {
      breakpoint: 1023,
      settings: {

        centerPadding: '0px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 640,
      settings: {
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    }
  ]
});





$(document).ready(function(){
  $('.news-block .box').slick({
  slidesToShow: 4,
  dots:false,
  arrows:false,
  centerMode: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1680,
      settings: {
        slidesToShow: 4,
        dots:false,
        arrows:false,
        centerMode: true,
		
      }
    },
    
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 3,
        dots:false,
        arrows:false,
        centerMode: true,
		
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        dots:false,
        arrows:false,
        centerMode: true,
      }
    },
	{
      breakpoint: 479,
      settings: {
        slidesToShow: 1,
        dots:false,
        arrows:false,
        centerMode: true,
      }
    },
    
  ]
  });
});







$(document).ready(function(){

  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  }


$(window).scroll(function(){
  if ($(window).scrollTop() >= 190) {
    $('.header-wrapper').addClass('fixed');
   }
   else {
    $('.header-wrapper').removeClass('fixed');
   }
});


});